import createContextProxy from 'src/state/context/contextProxy'
import type { PresentationBuilderStateType } from './PresentationBuilderStateProvider'

const presentationBuilderStateProvider = createContextProxy<PresentationBuilderStateType>('PresentationBuilder')

export const PresentationBuilderStateContext = presentationBuilderStateProvider.ContextProxy
export const PresentationBuilderStateProvider = presentationBuilderStateProvider.ContextProxyProvider
export const usePresentationBuilderState = presentationBuilderStateProvider.useProxy
